module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Sun-fog-270a935ddf8abbd19836d14dfc40d278.svg";